import React from 'react'

import { useSelector } from 'react-redux'
import { getGlobalSettingsState } from '../../../../utils/selectors'

import SplitPane from 'react-split-pane'
import InputSection from '../../views/Input'
import OutputSection from '../../views/Output'
import IllustrationSection from '../../views/Illustration'

const TabletView = () => {
  const orientation = useSelector((state) => getGlobalSettingsState(state).orientation)

  return (
    <SplitPane split="horizontal" defaultSize="33%" minSize="33%">
      <InputSection />
      <SplitPane split={orientation} defaultSize="33%" minSize="33%">
        <IllustrationSection />
        <OutputSection />
      </SplitPane>
    </SplitPane>
  )
}

export default TabletView
